import { IRequesterInfo } from '../../../base/models'
import { DirectResponseProxy } from '../../../base/proxy/clientProxy'

export class CompayPopupApi extends DirectResponseProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'compay-payment/generate-credit-agreement-pdf',
      requesterInfo,
    })
  }

  public async creditContractPopup(): Promise<any> {
    return await this.postAsync<any>()
  }
}
